<template>
  <div
    class="d-flex align-center justify-start mb-2 pl-1"
  >
    <v-icon
      v-if="!isLoading"
      color="orange500"
      size="15px"
      icon="$alert-circle"
    />
    <div
      v-else
      class="loading-icon-container d-flex align-center justify-center"
    >
      <div
        class="loading-icon"
      />
    </div>

    <span class="loading-text ml-2">{{ isLoading ? 'Loading...' : 'Type to search...' }}</span>
  </div>
</template>

<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="less" scoped>
.loading-text {
  font-size: 12px;
  font-weight: 300;
  color: @text-dark;
  transition: all 0.3s ease;
}

@keyframes loader {
  0% {
    width: 12px;
    height: 12px;
    background: @teal-500;
  }

  25% {
    width: 7px;
    height: 7px;
    background: @teal-500;
  }

  50% {
    width: 9px;
    height: 9px;
    background: @basic-blue;
  }

  75% {
    width: 7px;
    height: 7px;
    background: @basic-blue;
  }

  100% {
    width: 12px;
    height: 12px;
    background: @teal-500;
  }
}

.loading-icon {
  border-radius: 50%;
  animation: loader 2.5s infinite;
}

.loading-icon-container {
  width: 12px;
  height: 12px;
  opacity: 0.5;
}
</style>
